module.exports = __webpack_public_path__ + "img/bg.9dacc358.svg";